var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointRojo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_101",
    "data-name": "Elipse 101",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#d6073f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointRojo);
export default __webpack_public_path__ + "static/media/point-rojo.d86095355672a0f4a6a1a5054a0451a5.svg";
export { ForwardRef as ReactComponent };